import { createSelector, createFeatureSelector } from '@ngrx/store'
import { Role, RoleDetailState, RoleState } from './role.state'
import { selectRole } from './role.reducer'

// Select the feature state
export const selectRoleState = createFeatureSelector<RoleState>('role')

// Selector to get all businesses from the state
export const selectAllBusinesses = createSelector(
  selectRoleState,
  (state: RoleState) => state.roles
)

// Selector to get loading state
export const selectLoadingState = createSelector(
  selectRoleState,
  (state: RoleState) => state.loading
)

// Selector to get the error state
export const selectErrorState = createSelector(selectRoleState, (state: RoleState) => state.error)

export const selectRoleDetailState = createFeatureSelector<RoleDetailState>('roleDetail')
export const selectRoleDetail = createSelector(selectRole, state => {
  // console.log('selector state', state)
  return state || ({} as Role)
})

export const selectRoleDetailError = createSelector(
  selectRoleDetailState,
  (state: RoleDetailState) => state.error
)

export const selectUnassignedUsers = createSelector(selectRoleState, state => state.unassignedUsers)
